var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuPackages = function SvgMenuPackages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    clipPath: "url(#menu-packages_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 9.334h12M3.333 14.667l.977-.977c.23-.23.536-.368.86-.388l3.75-.234a2.67 2.67 0 0 0 1.807-.868l2.606-2.866H11L9.724 10.61c-.25.25-.59.39-.943.39h-.114m0 0v-.333c0-.737-.597-1.333-1.334-1.333H5.771c-.707 0-1.385.28-1.885.78l-2.553 2.553M8.667 11H6.333M3.333 7.667a5.333 5.333 0 0 1 5.334-5.333m0 0A5.333 5.333 0 0 1 14 7.667M8.667 2.334v-1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu-packages_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgMenuPackages;